<template>
    <app-layout>
        <div class="w-full bg-white purchase-checkout-result">
            <div class="py-16 px-4 flex justify-center gap-8 xl:gap-0 items-center mx-auto max-w-5xl flex-wrap">
                <div>
                    <h1 class="text-5xl font-semibold mb-10 text-center text-sky-300">
                        Thank You!
                    </h1>

                    <div class="mb-10 text-center">
                        <h1 class="text-2xl font-semibold text-orange-500">
                            Your purchase was successful
                        </h1>
                        <p class="font-semibold  text-orange-500">Order details: </p>
                        <p class="font-semibold text-orange-500">#{{ orderStore.order_id }}</p>
                        <p class="font-semibold text-orange-500">Email: {{ orderStore.user.email }}</p>
                        <p class="font-semibold text-orange-500">First name: {{ orderStore.user.first_name }}</p>
                        <p class="font-semibold text-orange-500">Last name: {{ orderStore.user.last_name }}</p>
                        <p class="font-semibold text-orange-500">Phone number: {{ orderStore.user.phone_number }}</p>
                        <p class="font-semibold text-orange-500">Total amount: ${{ orderStore.totalAmount }}</p>
                    </div>
                    <button
                        class="mb-10 btn pointer capitalize text-center text-xl font-semibold flex items-center gap-4 main-bg m-auto text-white border-none py-4 px-10 rounded-3xl"
                        @click="redirectAndClear"
                    >
                        Got to home page
                    </button>
                </div>
                <purchase-checkout-product-info />
            </div>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from "@/layouts/AppLayout";
import PurchaseCheckoutProductInfo from "./PurchaseCheckoutProductInfo";
import {mapGetters} from "vuex";
import _ from "lodash";
import { useOrderStore } from "../../../store/orderStore";

export default {
    name: "PurchaseCheckoutResult",
    components: {PurchaseCheckoutProductInfo, AppLayout},
    computed: {
        ...mapGetters({
            user: 'getUser',
            paymentData: 'getPaymentData',
            orderData: 'purchase/getOrderData',
            allOrderData: 'getAllOrderData',
            countryPackages: 'getCountryPackages',
        }),
    },

    setup() {
        const orderStore = useOrderStore();

        return { orderStore }
    },

    mounted() {
        window.dataLayer = window.dataLayer || [];
        this.allOrderData.forEach(order => {
            window.dataLayer.push({
                'event': 'purchase',
                'product': {
                    'order_id': order.order_id,
                    'total_amount': order.total_amount,
                    'plan_amount': order.plan_amount,
                    'coupon_code': order.coupon_code,
                    'coupon_amount': order.coupon_amount,
                    'number_of_devices': order.number_of_devices,
                    'number_of_days': order.number_of_days,
                    'gift_card_id': order.gift_card_id,
                },
                'shipping': {
                    'state': order.state,
                    'country': order.country,
                    'zip': order.zip_code,
                    'city': order.city,
                    'shipping_price': order.shipping_type_charges,
                },
                'user': {
                    'email': order.email,
                    'phone': order.phone_number,
                    'first_name': order.first_name,
                    'last_name': order.last_name,
                }
            });
        })
    },
    methods: {
        redirectAndClear() {
            this.$store.dispatch('purchase/clearOrderData');
            this.$store.dispatch('purchase/setActiveOrderDataIndex', -1);
            this.$router.push({ name: 'Home' });
        },
        handlePageUnload() {
            this.redirectAndClear();
        },
    },
    created() {
        window.addEventListener('beforeunload', this.handlePageUnload);
    },
    beforeDestroy() {
        window.removeEventListener('beforeunload', this.handlePageUnload);
    }

}
</script>

<style lang="scss">
    .purchase-checkout-result {
        &__container {
            display: flex;
            justify-content: center;
            padding: 4rem 0;
        }
    }
</style>